import { Injectable } from '@angular/core';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';
import {
    HttpClient,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DiscountCode } from '../models/consultdoctors';

interface DiscountFilterQuery {
    page_no: number;
    records_per_page: number;
    from_date: Date;
    to_date: Date;
    country_id: number;
    is_active: boolean;
    discount_code: string;
    discount_percent: number;
}

@Injectable({
    providedIn: 'root'
})
export class RefferalDiscountService {
    constructor(private readonly http: HttpClient) { }


    getRefferalTypes1(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.RefferalDiscountApi + 'fetch/referraltype/')
            .pipe(catchError(this.handleError));
    }

    saveDiscountCode(body: any): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.RefferalDiscountApi + 'create', body)
            .pipe(catchError(this.handleError));
    }

    getDicountCodeList(body: DiscountFilterQuery): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.RefferalDiscountApi + 'fetch/all', body)
            .pipe(catchError(this.handleError));
    }

    updateDicountCode(discount_id: string, body): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.RefferalDiscountApi + 'update/' + discount_id,
                body
            )
            .pipe(catchError(this.handleError));
    }

    applyDiscountCodeAtConsultation(body: DiscountCode): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.PatientApi + 'discount/validate', body)
            .pipe(catchError(this.handleError));
    }

    getPatientApplicableDiscountCopounList(patient_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PatientApi + patient_guid + '/discount_coupons/list')
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }


    // getCountries():Observable<Country[]>{
    //     // return this.http.get<Country[]>('http://localhost:3000/api/countries',{headers:this.headers});
    //     return this.http.get<Country[]>(RestApi.Urls.CountryApi + 'GetAllSupported').pipe(catchError(this.handleError));
    // }
}
